<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <app-header [configuration]="configurationTable" (action)="reloadTable($event)" ></app-header>
                    <div class="list-product custom-scrollbar">
                        <div class="mb-3 row">
                            <label for="table-complete-search" class="col-xs-3 col-sm-auto col-form-label">Buscar</label>
                            <div class="col-xs-3 col-sm-auto">
                                <input id="table-complete-search" type="text" class="form-control" name="searchTerm" [(ngModel)]="service.searchTerm">
                            </div>
                            @if (service.loading$ | async) {
                                <span class="col col-form-label">Cargando ...</span>
                            }
                        </div>
                        <div class="list-product table-responsive custom-scrollbar">
                            <table class="table datatable-table" id="project-status">
                                <thead>
                                <tr>
                                    <th *ngFor="let column of columns">
                                        <span class="f-light f-w-600">{{ column.title || column.btnName }}</span>
                                    </th>
                                </tr>
                                </thead>
                                <tbody *ngIf="(service.loading$ | async)">
                                    <tr>
                                        <td class="datatable-empty text-center" [attr.colspan]="columns.length + 1">Cargando información, por favor espera...</td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="!(service.loading$ | async)">
                                <!-- Recorre los datos para generar las filas -->
                                <tr *ngFor="let item of dataTable">
                                    <td *ngFor="let column of columns" [ngClass]="(column?.options)? 'status':''">
                                        @if (column.type === 'images') {
                                            <!-- Mostrar la imagen si el tipo es 'images' -->
                                            <img *ngIf="item[column.id]" [src]="item[column.id]" alt="Image" style="width: 50px; height: 50px; object-fit: cover;">
                                        } @else if (column.type === 'currency') {
                                            <!-- Mostrar dinero -->
                                            <p class="f-light">{{ item[column.id] | currency }}</p>
                                        } @else if (column.type === 'link') {
                                            <!-- Mostrar link -->
                                            <button type="button" class="btn btn-link" (click)="executeAction(column.action, item)">{{ item[column.id] }}</button>
                                        } @else if (column.type === 'status'){
                                            <ng-container *ngFor="let option of column.options">
                                                <ng-container *ngIf="option.name === item[column.id]">
                                                    <app-feather-icons class="bg-light-{{ option.class }} font-{{ option.class }}"
                                                                       [icons]="option.icon"></app-feather-icons>
                                                    <span class="font-{{ option.class }}" style="top: -10px;position: relative;">{{ item[column.id] }}</span>
                                                </ng-container>
                                            </ng-container>

                                        } @else {
                                            <!-- Mostrar texto -->
                                            <p class="f-light">{{ item[column.id] }}</p>
                                        }

                                        <!--Mostrar botones-->
                                        <ng-container *ngIf="!column.id && column.actions">
                                            <div class="product-action">
                                                @for (action of column.actions; track action) {
                                                    <div [ngClass]="(action?.type == null) ? '' : 'icon-button'">
                                                        <button *ngIf="(action?.type != null)" class="{{action.type.class}}" (click)="executeAction(action.action, item)" placement="top" ngbTooltip="{{action.btnName}}" [ngClass]="(action.type.condition && item[action.type.condition]) ? 'active':''">
                                                            <app-feather-icons [icons]="action.type.icons"></app-feather-icons>
                                                        </button>

                                                        <button *ngIf="(action?.type == null)" class="btn btn-sm" (click)="executeAction(action.action, item)"
                                                                [ngClass]="(action.btnName !== 'Editar' && action.btnName !== 'Eliminar')? 'btn-primary':''">
                                                            <!-- Muestra el icono solo si la acción es Editar o Eliminar-->
                                                            <app-common-svg-icons *ngIf="action.btnName === 'Editar'" [icons]="'edit-content'"></app-common-svg-icons>
                                                            <app-common-svg-icons *ngIf="action.btnName === 'Eliminar'" [icons]="'trash1'"></app-common-svg-icons>
                                                            <!-- Muestra el texto si no es Editar ni Eliminar -->
                                                            <span *ngIf="(action.btnName !== 'Editar' && action.btnName !== 'Eliminar')">{{ action.btnName }}</span>
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        </ng-container>
                                    </td>
                                </tr>
                                <!-- Muestra un mensaje si no hay datos -->
                                <tr *ngIf="dataTable.length === 0">
                                    <td class="datatable-empty" [attr.colspan]="columns.length + 1">Sin registros</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                        <div class="d-flex justify-content-between p-2">
                            <select class="form-select" style="width: auto" name="pageSize" [(ngModel)]="service.pageSize">
                                <option [ngValue]="10">10 registros por página</option>
                                <option [ngValue]="25">25 registros por página</option>
                                <option [ngValue]="50">50 registros por página</option>
                                <option [ngValue]="100">100 registros por página</option>
                            </select>
                            <ngb-pagination [collectionSize]="(total$ | async)!" [(page)]="service.page"
                                            [pageSize]="service.pageSize"> </ngb-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
